import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setActiveRoomColoringIdInRedux } from "../DesignTab/designSlice";

export const useHydrateActiveRoomColoringIdFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const current = useAppSelector((state) => state.design.activeRoomColoringId);
  const hasHydratedRef = useRef(false);

  useEffect(() => {
    if (hasHydratedRef.current) return;
    hasHydratedRef.current = true;

    const colorParam = searchParams.get("color");
    if (colorParam == null) return;

    const normalized = colorParam.trim();
    const next = normalized.length > 0 ? normalized : undefined;

    if (next !== current) {
      dispatch(setActiveRoomColoringIdInRedux(next));
    }
  }, [current, dispatch, searchParams]);
};
